export default class TextUtil {
  /**
   * 半角文字チェック
   * @param string
   * @returns
   */
  static isHankaku(string: string) {
    if (string === '\n') {
      return true;
    }
    if (string && string.length === 1) {
      const cd: number = string.charCodeAt(0);
      return ((cd >= 32 && cd <= 126) || (cd >= 65377 && cd <= 65439)); // JIS互換 or 半角カナ
    }
    return false;
  }

  /**
   * 空白文字か否か
   * @param {string} character
   * @returns {boolean}
  */
  static isWhitespace(character:string):boolean {
    switch (character) {
      case ' ':
      case '\t':
      case '\r':
      case '\n':
      case '\f':
        return true;
      default:
        return false;
    }
  }

  /**
   * テキストの幅と高さを計算する
   * @param allText
   * @param fontFamily
   * @param fontSize
   * @returns json
   */
  static getTextSizeWh(allText: string, fontFamily: string, fontSize: number) {
    const svg = document.getElementById('textDummyContainerSvg');
    svg.innerHTML = '';
    const gPath = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const textLineArray = allText.split('\n');
    let textHeight: number = 0;
    const widthArray: number[] = [];
    let textWidth: number = 0;
    for (let i = 0; i < textLineArray.length; i += 1) {
      const textPath = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      textPath.setAttribute('fill', 'none');
      textPath.setAttribute('font-family', String(fontFamily));
      textPath.setAttribute('font-size', String(fontSize));
      textPath.textContent = textLineArray[i];
      gPath.append(textPath);
      svg.appendChild(gPath);
      const bbox = textPath.getBoundingClientRect();
      textHeight += bbox.height;
      widthArray.push(bbox.width);
    }
    textWidth = Math.max.apply(null, widthArray);
    gPath.remove();
    return { width: textWidth, height: textHeight, widthList: widthArray };
  }

  /**
   * テキスト項目に複数行があることを確認してください
   * @param text
   * @returns boolean
   */
  static isMultiLineText(text: string): boolean {
    if (text.indexOf('\n') !== -1) {
      return true;
    }
    return false;
  }
}
